import { render, staticRenderFns } from "./CanvasImage.vue?vue&type=template&id=45dc7af8&"
import script from "./CanvasImage.vue?vue&type=script&lang=js&"
export * from "./CanvasImage.vue?vue&type=script&lang=js&"
import style0 from "./CanvasImage.vue?vue&type=style&index=0&id=45dc7af8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports